import { ACTION_TYPE_PREFIX } from "../../config";

export const RESET = `${ACTION_TYPE_PREFIX}/error/RESET`;
